import { render, staticRenderFns } from "./QuickMenuLink.vue?vue&type=template&id=0d1b47d7&"
import script from "./QuickMenuLink.vue?vue&type=script&lang=js&"
export * from "./QuickMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1b47d7')) {
      api.createRecord('0d1b47d7', component.options)
    } else {
      api.reload('0d1b47d7', component.options)
    }
    module.hot.accept("./QuickMenuLink.vue?vue&type=template&id=0d1b47d7&", function () {
      api.rerender('0d1b47d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/QuickMenuLink.vue"
export default component.exports